import { UserChatType } from "frontend-lib/DomainTypes/Conversation";

export type MessageMeta = {
    from: UserChatType & "SERVER";
    payload?: ServerPayload;
};

type ServerPayload = {
    serverMessageType: "OPENED" | "CLOSED_BY_USER" | "CLOSED_BY_SYSTEM" | string; // Add more types to narrow the scope if needed
};

export function newMessageMeta(messageFromApi: any): MessageMeta | undefined {
    const m = messageFromApi;
    if (m.messageFrom !== "SERVER") return;

    return {
        from: m.messageFrom,
        payload: {
            serverMessageType: m.messagePayload.serverMessageType,
        },
    };
}
